"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtuPerCubicFeet = exports.KiloJoulePerCubicMeter = exports.KiloWattHourPerCubicMeter = void 0;
var uom_1 = require("uom");
// Energy per volume
exports.KiloWattHourPerCubicMeter = uom_1.UnitFormat.createUnitFormat("kWh/m³", 2);
exports.KiloJoulePerCubicMeter = uom_1.UnitFormat.createUnitFormat("kJ/m³", 2);
exports.BtuPerCubicFeet = uom_1.UnitFormat.createUnitFormat("BTU/ft³", 2);
//# sourceMappingURL=heating-value-format.js.map